import React, { useEffect, useLayoutEffect, useState } from "react";
import "./Voucher.scss";
import {
  Button,
  Col,
  Form,
  Row,
  Space,
  Table,
  notification,
  message,
} from "antd";
import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import { ExcelSVG } from "assets";
import Icon from "assets/icons";
import { columnsPrepay } from "./Voucher.config";
import { discountsService, payService } from "api";
import dayjs from "dayjs";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { InputFields, ListActionButton } from "components/common";
import { setCallApi, setIdSecond } from "redux/reducer/reduxCommon";
import { FORMAT_TIME, tabKeys } from 'types/enums';
import Notification from "components/common/notification/notification";
import ModalDetailVoucher from "./ModalDetailVoucher/ModalDetailVoucher";
import { setIdKM } from "redux/reducer/employee";
const Voucher = ({tabKey}) => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [data, setData] = useState(null);
  const [limit, setLimit] = useState(null);
  const [loadingTable, setLoadingTable] = useState(true);
  const [isSelectedEnableNull, setIsSelectedEnableNull] = useState(false);
  // console.log(isSelectedEnableNull);
  const [currentPage, setCurrentPage] = useState(1);
  const [form] = Form.useForm();
  const [dataPrepay, setDataPrepay] = useState(null);
  let id = useAppSelector((state) => state.employeesReducer.idKM);
  const idPK = useAppSelector((state) => state.reduxCommon.id);
  const idBN = useAppSelector((state) => state.reduxCommon.maBenhNhan);
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [record, setRecord] = useState(null);
  const [idKM, setidKM] = useState(null);
  // console.log("dataPrepay",dataPrepay);
  // console.log("idKM",idKM);

  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
  const dispatch = useAppDispatch();
  const [isAnyEnable, setIsAnyEnable] = useState(false);
  const [areAllNull, setAreAllNull] = useState(false);
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  console.log(tabKey);
  
  useEffect(() => {
    if(tabKey === "VOUCHER")
      {
        getList();
      }
  }, [id, params, idBN, idPK,tabKey]);
  const handleHuyApDung = async () => {
    setLoadingTable(true);
    try {
      const idDichVuValue = dataPrepay.length > 0 ? dataPrepay[0] : null;
      const idDichVuOrKm = idDichVuValue ?? idKM;
      const datas = {
        maPhieuKham: idPK,
        maBenhNhan: idBN,
        idDichVu: idDichVuOrKm,
      };
      //  console.log(datas);
      const response = await discountsService.huyApDung(datas);
      //  console.log(response);
      Notification("success", response.message);
      setIsSelectedEnableNull(false);
      getList();
      setLoadingTable(false);
    } catch (e) {
      if (e.response.status === 400) {
        Notification("error", e.response.data.message);
      } else {
        Notification("error", e.message);
      }
      setLoadingTable(false);
    }
  };
  const handleApDung = async () => {
    setLoadingTable(true);
    try {
      const datas = { maPhieuKham: idPK, maBenhNhan: idBN, idDichVu: idKM };
      //  console.log(datas);

      const response = await discountsService.apDung(datas);
      Notification("success", response.message);
      setIsSelectedEnableNull(false);
      getList();
      setLoadingTable(false);
    } catch (e) {
      if (e.response.status === 400) {
        Notification("error", e.response.data.message);
      } else {
        Notification("success", e.message);
      }
      setLoadingTable(false);
    }
  };
  const getList = async () => {
    setLoadingTable(true);
    try {
      const paramss = { ...params, idLanKham: idPK, idBenhNhan: idBN };
      const response = await discountsService.searchTTKM(paramss);
      setLimit(response);
      const newData = response.data?.map((item) => ({
        ...item,
        key: item?.id,
        tenGoiDichVu: item.goiDichVuDtos
          ?.map((itemm) => itemm?.tenGoiDichVu)
          .join("<br>"),
        tenDichVu: item.dichVuDtos
          ?.map((itemm) => itemm?.tenDichVu)
          .join("<br>"),
        // status: 1,
      }));
      const enabledKeys = newData
        ?.filter((item) => item?.isEnable)
        ?.map((item) => item?.id);
      setSelectedRowKeys(enabledKeys);
      setDataPrepay(enabledKeys);
      setData(newData);
      // Kiểm tra nếu có bất kỳ item nào có isEnable là true
      setIsAnyEnable(newData?.some((item) => item?.isEnable));
      const allNull = newData?.every((item) => item?.isEnable === null);
      setAreAllNull(allNull);
      setLoadingTable(false);
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi load danh sách chương trình khuyến mãi"
      );
      setLoadingTable(false);
    }
  };

  columnsPrepay.map((e) => {
    if (e.key == "action") {
      e.render = (value, record, index) => {
        return (
          <ListActionButton
            showDetailFunction={() => handleOnShowDetail(record)}
          ></ListActionButton>
        );
      };
    }
    if (e.dataIndex == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        // console.log(rowNumber);

        return rowNumber;
      };
    }
  });
  // columnsPrepay.map((e) => {
  //   if (e.dataIndex == "stt") {
  //     e.render = (text, record, index) => {
  //       const rowNumber = (currentPage - 1) * params.limit + index + 1;
  //       return rowNumber;
  //     };
  //   }
  // });
  const handleOnShowDetail = (record) => {
    // console.log(record.id);
    setRecord(record.id);
    setIsShowModal(true);
    dispatch(setIdKM(record.id));
  };
  const handleOk = () => {
    setIsShowModal(false);
  };

  const handleCancel = () => {
    setIsShowModal(false);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      // Chỉ giữ lại row cuối cùng được chọn
      setSelectedRowKeys([selectedRowKeys[selectedRowKeys.length - 1]]);
      const lastSelectedRowId = selectedRowKeys[selectedRowKeys.length - 1];
      setidKM(lastSelectedRowId);
      // console.log("âsdad",lastSelectedRowId);
      const hasEnableNull = selectedRows.some((row) => row.isEnable === null);
      setIsSelectedEnableNull(hasEnableNull);
      // Lấy ra row cuối cùng được chọn và có status == 1
      const lastSelectedRow = selectedRows.find((row) => row.key === row.key);
      // Nếu có row cuối cùng thỏa mãn điều kiện, cập nhật lại data
      if (lastSelectedRow) {
        //  setDataPrepay({...lastSelectedRow, idCheckbox: true});
        setDataPrepay(lastSelectedRow.id);
        // selectedRowKeys({lastSelectedRow,idCheckbox: true});
        // console.log("lastSelected",{...lastSelectedRow,isEnable: true});
      } else {
        setDataPrepay(null); // Nếu không có row thỏa mãn điều kiện, xóa data
      }
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  return (
    <div className="tab-cancel-pay-container">
      <Space direction="vertical" size={"middle"} style={{ width: "100%" }}>
        <Row justify={"end"} align={"middle"}>
          {/* <Col>
            <Checkbox.Group options={checkboxOption} onChange={(e) => {}} />
          </Col> */}
          <Col>
            <Button
              type="primary"
              danger
              onClick={handleHuyApDung}
              disabled={areAllNull || !dataPrepay || dataPrepay === 0}
              style={{ marginRight: "5px" }}
            >
              Hủy áp dụng
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={handleApDung}
              disabled={!isSelectedEnableNull}
            >
              Áp dụng
            </Button>
          </Col>
        </Row>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            <Form component={false}>
              <Table
                loading={loadingTable}
                bordered
                dataSource={data}
                columns={columnsPrepay}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: limit?.total,
                  pageSize: limit?.limit,
                  current: limit?.page,
                  onChange: onChangePagination,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    onDoubleClick: (e) => handleOnShowDetail(record),
                  };
                }}
                rowSelection={{
                  ...rowSelection,
                }}
              />
            </Form>
          </Col>
        </Row>
      </Space>
      <ModalDetailVoucher
        isShowModal={isShowModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
    </div>
  );
};

export default Voucher;
